import { FelaComponent, createComponent } from "react-fela";
import Visual from "~/components/shared/visual";
import { textStyles } from "~/styleguide/typography";

export default function People({ people, extend }) {
    return (
        <Container extend={extend}>
            {people.map((person, index) => {
                if (!person) return null;

                return (
                    <Person key={index}>
                        {person.headshot && (
                            <Visual
                                extend={headshotStyles}
                                image={person.headshot}
                                background="cover"
                            />
                        )}

                        <FelaComponent style={personDetailStyles}>
                            {person.name && (
                                <PersonName extend={personNameStyles}>
                                    {person.name}
                                </PersonName>
                            )}

                            {person.title && (
                                <FelaComponent
                                    as="p"
                                    style={textStyles.paragraphSmall}
                                >
                                    {person.title}
                                </FelaComponent>
                            )}
                        </FelaComponent>
                    </Person>
                );
            })}
        </Container>
    );
}

const Container = createComponent(() => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 40
}));

const Person = createComponent(() => ({
    width: "calc(50% - 10px)",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    marginTop: 0,
    minWidthTabletLandscape: {
        ":nth-child(1n+3)": {
            marginTop: 20
        }
    },

    maxWidthTabletLandscape: {
        marginBottom: 20,
        minWidthTablet: {
            width: "100%",
            marginBottom: 0,
            ":not(:last-of-type)": { marginBottom: 20 }
        },
        maxWidthMobile: {
            width: "100%",
            marginBottom: 0,
            ":not(:last-of-type)": { marginBottom: 20 }
        }
    }
}));

const PersonName = createComponent(() => textStyles.faqOrFeature, "h5");

const headshotStyles = {
    width: 72,
    height: 72,
    borderRadius: "50%",
    marginRight: 12,
    overflow: "hidden",
    "> .vv-visual": {
        width: "100%",
        height: "100%",
        borderRadius: "50%"
    },
    "> .vv-image": {

    }
};

const personNameStyles = {
    width: "100%",
    display: "block"
};

const personDetailStyles = {
    display: "flex",
    flexWrap: "wrap",
    width: "calc(100% - 72px - 12px)"
};
